import { useState, useEffect, useRef } from 'react';

// Animates from 0 to `target` over `duration` ms using ease-out cubic.
// Returns current animated value. Re-fires every time `target` changes.
export function useCountUp(target, { duration = 700, enabled = true } = {}) {
  const [current, setCurrent] = useState(0);
  const rafRef = useRef(null);

  useEffect(() => {
    if (!enabled || target === null || target === undefined) {
      setCurrent(0);
      return;
    }

    const to        = target;
    const startTime = performance.now();

    const tick = (now) => {
      const elapsed  = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased    = 1 - Math.pow(1 - progress, 3); // ease-out cubic
      setCurrent(to * eased);

      if (progress < 1) {
        rafRef.current = requestAnimationFrame(tick);
      } else {
        setCurrent(to);
      }
    };

    rafRef.current = requestAnimationFrame(tick);
    return () => { if (rafRef.current) cancelAnimationFrame(rafRef.current); };
  }, [target, duration, enabled]);

  return current;
}
